import React, {Component} from "react"
import styles from "./edit-button.module.css"
import {ReactComponent as Icon} from "./edit.svg"

interface Props {
    disabled?: boolean
    onClick: () => void
}

export class EditButton extends Component<Props, {}> {
    public render() {
        const {disabled, onClick} = this.props
        return (
            <button className={styles.button} onClick={onClick} disabled={disabled}>
                <Icon width="14" height="14" className={styles.icon} />
            </button>
        )
    }
}
